import { useEffect, useMemo, useState } from 'react'
import { createLatestLoader, type RemoteState } from './latest-loader'

export function useRemoteData<T>(request: (() => Promise<T>) | null) {
  const [state, setState] = useState<RemoteState<T>>({ data: null, loading: true, error: false })
  const loader = useMemo(() => createLatestLoader<T>(setState), [])
  const [revision, setRevision] = useState(0)
  useEffect(() => {
    if (request) void loader.load(request)
    else setState({ data: null, loading: false, error: false })
    return () => loader.cancel()
  }, [loader, request, revision])
  return { ...state, retry: () => setRevision(value => value + 1) }
}
